//-----------------------------
// get string after last slash
//-----------------------------
export default function getStringAfterLastSlash(url) {
    return url.split("/").pop();
}